var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "#44474B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1958 4.94603C13.1958 4.56176 12.8843 4.25024 12.5 4.25024C12.1157 4.25024 11.8042 4.56176 11.8042 4.94603V11.8045H4.94578C4.56151 11.8045 4.25 12.116 4.25 12.5002C4.25 12.8845 4.56151 13.196 4.94578 13.196H11.8042V20.0545C11.8042 20.4387 12.1157 20.7502 12.5 20.7502C12.8843 20.7502 13.1958 20.4387 13.1958 20.0545V13.196H20.0542C20.4385 13.196 20.75 12.8845 20.75 12.5002C20.75 12.116 20.4385 11.8045 20.0542 11.8045H13.1958V4.94603Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus24);
export default __webpack_public_path__ + "static/media/icon_plus_24.1f7b6925.svg";
export { ForwardRef as ReactComponent };